// 商品系统--分类管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

export class CommodityCategoryApi {

    constructor() {
    }
    protected static groupUrl = '/category';

    //获取所有分类
    public static async getCategoryList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }

    //保存分类
    public static async saveCategory(data) {
        let uri = this.groupUrl + '/save';
        return await ServerDistApi.send(uri, data);
    }

    //删除分类
    public static async deleteCategory(data){
        let uri = this.groupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }
}


